import gql from "graphql-tag";

export default gql`
  query {
    organismIDs(last: 1) {
      organismID
    }
  }
`;
